export function fraction(num: number) {
	const {fraction, whole} = parseFraction(num);

	if (!fraction) return whole;

	if (fractionsUnicodeMap[fraction]) {
		return `${whole}${fractionsUnicodeMap[fraction]}`;
	}

	const [numerator, denominator] = fraction.split('/');
	const numeratorUnicode = getUnicodeString(numeratorMap, numerator);
	const denominatorUnicode = getUnicodeString(denominatorMap, denominator);
	return `${whole}${numeratorUnicode}/${denominatorUnicode}`;
}

function highestCommonFactor(u: number, v: number) {
	let U = u,
		V = v;
	while (true) {
		if (!(U %= V)) return V;
		if (!(V %= U)) return U;
	}
}

function parseFraction(decimal: number): {whole: string; fraction: string | null} {
	const whole = String(decimal).split('.')[0];
	decimal = parseFloat('.' + String(decimal).split('.')[1]);
	if (!decimal) return {whole, fraction: null};

	let num: number = 10 ** (String(decimal).length - 2);
	decimal = decimal * num;

	for (let z = 2; z < decimal + 1; z++) {
		if (decimal % z == 0 && num % z == 0) {
			decimal = decimal / z;
			num = num / z;
			z = 2;
		}
	}
	//if format of fraction is xx/xxx
	if (decimal.toString().length == 2 && num.toString().length == 3) {
		//reduce by removing trailing 0's
		decimal = Math.round(Math.round(decimal) / 10);
		num = Math.round(Math.round(num) / 10);
	}
	//if format of fraction is xx/xx
	else if (decimal.toString().length == 2 && num.toString().length == 2) {
		decimal = Math.round(decimal / 10);
		num = Math.round(num / 10);
	}
	//get highest common factor to simplify
	const t = highestCommonFactor(decimal, num);
	return {whole, fraction: decimal / t + '/' + num / t};
}

const numeratorMap = {
	0: '⁰',
	1: '¹',
	2: '²',
	3: '³',
	4: '⁴',
	5: '⁵',
	6: '⁶',
	7: '⁷',
	8: '⁸',
	9: '⁹',
};

const denominatorMap = {
	0: '₀',
	1: '₁',
	2: '₂',
	3: '₃',
	4: '₄',
	5: '₅',
	6: '₆',
	7: '₇',
	8: '₈',
	9: '₉',
};

function getUnicodeString(mapProvider: Record<string | number, string>, number: number | string): string {
	return [...String(number)]
		.map(Number)
		.map((n) => mapProvider[n])
		.join('');
}

const fractionsUnicodeMap: Record<string, string> = {
	'1/2': '½',
	'1/3': '⅓',
	'2/3': '⅔',
	'1/4': '¼',
	'3/4': '¾',
	'1/5': '⅕',
	'2/5': '⅖',
	'3/5': '⅗',
	'4/5': '⅘',
	'1/6': '⅙',
	'5/6': '⅚',
	'1/7': '⅐',
	'1/8': '⅛',
	'3/8': '⅜',
	'5/8': '⅝',
	'7/8': '⅞',
	'1/9': '⅑',
	'1/10': '⅒',
};
